module.exports = __webpack_public_path__ + "img/bidding.cf7641ca.png";